export class PdfJsHelper {
    /**
     * Backend provides dimensions for pdf pages, these are floored values so to ensure correct equality we must floor the values from pdfjs
     */
    static calculatePageDimensions(pdfJsPage) {
        const defaultViewport = pdfJsPage.getViewport({ scale: 1 });
        return { width: Math.floor(defaultViewport.width), height: Math.floor(defaultViewport.height) };
    }
}
//# sourceMappingURL=pdfjs.helper.js.map